module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"toaster":"Your skilled worker visa service\\nhas been started","archived":{"subtitle":"Archived","eligibilityStatus":"Eligibility status","text":"To resume working with the candidate,\\nclick ‘Unarchive’","checkReport":"Check report","unarchive":"Unarchive"}}}')
  delete Component.options._Ctor
}
